import { useCallback, useState } from 'react'

import ManualContent from './ManualContent'
import ScriptureModal from '../../general/ScriptureModal'
import FloatingManualNav from '../../floating-navs/floating-manual-nav'
import ImageLightbox from '../atoms/ImageLightbox'
import useFloatingNavVisibility from '../../../hooks/useFloatingNavVisibility'
import useImageLightbox from '../../../hooks/useImageLightbox'
import { IManual } from '../../../utils/types'

const ManualContainer = ({ manual }: { manual: IManual }) => {
	const [isScriptureModalShown, setIsScriptureModalShown] = useState(false)
	const [scriptureTextString, setScriptureTextString] = useState('')

	const isFloatingNavShown = useFloatingNavVisibility()
	const { lightboxSrc, closeLightbox, overlayRef } = useImageLightbox()

	const handleBibleTextClickModal = useCallback((bibleText: string) => {
		setScriptureTextString(bibleText)
		setIsScriptureModalShown(true)
	}, [])

	const closeScriptureModal = useCallback(() => {
		setIsScriptureModalShown(false)
	}, [])

	return (
		<div className='manual-content-area'>
			<ManualContent manual={manual} onBibleTextClick={handleBibleTextClickModal} />
			<ScriptureModal scriptureText={scriptureTextString} isOpen={isScriptureModalShown} handleModalClose={closeScriptureModal} />
			<FloatingManualNav manual={manual} isShown={isFloatingNavShown} />
			{lightboxSrc && <ImageLightbox src={lightboxSrc} overlayRef={overlayRef} onClose={closeLightbox} />}
		</div>
	)
}

export default ManualContainer
